import { withInstall } from '@vuemap/vue-amap-util'
import ToolBar from './ToolBar.vue'

export const ElAmapControlToolBar = withInstall(ToolBar)
export default ElAmapControlToolBar
